module.exports = __webpack_public_path__ + "img/2anos.67c27591.png";